/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";
import { IFile, IResponseShowFiles } from "@/interfaces/file";
import {
  IActivityFile,
  IResponseListActivityFile,
  IResponseShowActivityFile,
} from "@/interfaces/activityFiles";
import { BASE_URL } from "../api/config";

const BASE_FILES = "/files";
const BASE_ACTIVITY_FILES = "/activity_files";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "indices", skipNulls: true, encode: true });

export async function createFile({ file }: { file: IFile }) {
  const { data } = await api.post<IResponseShowFiles>(BASE_FILES, { file });
  return data;
}

export async function deleteActivityFile({
  idActivityFile,
}: {
  idActivityFile: number;
}) {
  const { data } = await api.delete<IResponseShowActivityFile>(
    `${BASE_ACTIVITY_FILES}/${idActivityFile}`,
  );
  return data;
}

export async function createActivityFile({
  activityFile,
}: {
  activityFile: IActivityFile;
}) {
  const { data } = await api.post<IResponseShowActivityFile>(
    BASE_ACTIVITY_FILES,
    { activityFile },
  );
  return data;
}

export async function updateActivityFile({
  idActivityFile,
  activityFile,
}: {
  idActivityFile: string | number;
  activityFile: Partial<IActivityFile>;
}) {
  const { data } = await api.put<IResponseShowActivityFile>(
    `${BASE_ACTIVITY_FILES}/${idActivityFile}`,
    { activityFile },
  );
  return data;
}

export async function listActivityFile({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListActivityFile>(
    BASE_ACTIVITY_FILES,
    {
      params: { filter, includes, page, limit, select },
      paramsSerializer: (params) => serialize(params),
    },
  );
  return data;
}

// Helpers de URL (view/download)
export function getUrlFile(
  idFile: string | number,
  thumbnail?: "large" | "medium" | "small" | "xlarge",
) {
  const query = serialize({ thumbnail });
  return `${BASE_URL}${BASE_FILES}/${idFile}/view${query ? `?${query}` : ""}`;
}

export function getUrlFileDownload(
  idFile: string | number,
  thumbnail?: "large" | "medium" | "small",
) {
  const query = serialize({ thumbnail });
  return `${BASE_URL}${BASE_FILES}/${idFile}/download${query ? `?${query}` : ""
    }`;
}
